import React from "react"
import { Card, CardHeader, CardBody, CardTitle } from 'reactstrap'
import PropTypes from 'prop-types'
import { Star } from "phosphor-react"
import profileCardBg from '../../assets/img/main/profile_card_bg.png'
import thirdCertificateGrey from '../../assets/img/main/1st-place-grey.png'
import thirdCertificate from '../../assets/img/main/1st-place.png'
import secondCertificateGrey from '../../assets/img/main/2nd-place-grey.png'
import secondCertificate from '../../assets/img/main/2nd-place.png'
import firstCertificateGrey from '../../assets/img/main/3rd-place-grey.png'
import firstCertificate from '../../assets/img/main/3rd-place.png'
import forthCertificateGrey from '../../assets/img/main/star-medal-grey.png'
import forthCertificate from '../../assets/img/main/star-medal.png'
import Skeleton from '../UI/Skeleton'
import { isEmpty, removeTags } from "../../lib/lib"
import { withTranslation } from 'react-i18next'
import api from '../../api/api'
import Cookies from 'universal-cookie'
import { processError } from '../../lib/lib'
import DefaultGrade from '../../assets/img/default-avatar.png'
import { StyledNavLink, Grid, HoverText, UserStatus } from "./styled"
const cookies = new Cookies()

class AchieveCard extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            imageLoaded: false,
            grade: null,
            daysLeft: 0,
        }
    }

    getGrade(data) {
        return new Promise((resolve, reject) => {
            api.getGrade(data).then((res) => resolve(res)).catch((e) => reject(e))
        })
    }

    async componentWillMount() {
        if (this.props.widgetType === 'grade') {
            const token = cookies.get('accessToken')
            const lang = this.props.i18n.language
            this.getGrade({ token, lang })
                .then(({ data }) => {
                    const qualDate = Date.now() + data.current.endDate * 1000
                    const now = Date.now()
                    let daysLeft = 0
                    if (qualDate - now > 0) {
                        const diffTime = Math.abs(new Date(now) - new Date(qualDate))
                        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) 
                        daysLeft = diffDays
                    }
                    data.grades = data.grades && data.grades.length ? data.grades.sort((a, b) => {
                        var x = a['position']; var y = b['position']
                        return ((x < y) ? -1 : ((x > y) ? 1 : 0))
                    }) : []
                    this.setState({ grade: data, daysLeft })
                })
                .catch((e) => processError(e, this.props.history))
        }
    }

    render() {
        const { t } = this.props
        return (
            <React.Fragment>
                {
                    this.props.widgetType === 'grade' &&
                     <Card className="main-profile d-flex flex-column">
                         <CardHeader className="header">
                             <div className="content">
                                 <CardTitle className="title xl-font-size">{t('main-profile')}</CardTitle>
                             </div>
                             <img className="profile-card-bg" src={profileCardBg} alt="" width={309} height={157}></img>
                             <div className="profile-img-wrapper d-flex">
                                 {
                                     this.state.grade ?
                                         <img className="profile-card-img" width="128" height="128" src={this.state.grade.current.image ? `${this.props.imageUrl}/${this.state.grade.current.image}` : DefaultGrade} alt=""></img>
                                         :
                                         <Skeleton className="profile-card-img" circle={true} height={128} width={128} />
                                 }
                             </div>
                         </CardHeader>
                         <CardBody className="body">
                             <div className="content">
                                 {
                                     this.state.grade ?
                                         <React.Fragment>
                                             {
                                                 this.state.grade.current && this.state.grade.current.name ?
                                                     <div className="name lg-font-size">{this.state.grade.current.name}</div> 
                                                     : ''
                                             }
                                         </React.Fragment>
                                         :
                                         <React.Fragment>
                                             <Skeleton className="name lg-font-size" width={150} />
                                             <Skeleton className="name lg-font-size" width={75} />
                                         </React.Fragment>
                                 }
                                 {
                                     this.state.grade && this.state.grade.user && this.state.grade.user.membership !== null ?
                                         <React.Fragment>
                                             {this.state.grade.user.membership ?
                                                 <div className="vip">
                                                     <Star size={20} weight="fill" className="icon" />
                                                     <div className="text sm-font-size">{t('main-vip-member')} ({this.state.grade.user.membershipEnd})</div>
                                                 </div> :
                                                 <div className="vip">
                                                     <Star size={20} weight="bold" color="#AFAFAF" />
                                                     <div className="text sm-font-size">{t('main-vip-notmember')}</div>
                                                 </div>
                                             }
                                         </React.Fragment>
                                         :
                                         <div className="vip">
                                             <Skeleton className="text sm-font-size" width={200} />
                                         </div>
                                 }
                                 {
                                     this.state.grade !== null ?
                                         
                                         <div className="grade">
                                             {
                                                 this.state.grade.grades && this.state.grade.grades.length ?
                                                     <Grid columns={this.state.grade.grades.length}>
                                                         {
                                                             this.state.grade.grades.map(({desc, active}, index) => (
                                                                 <HoverText key={index} className="hovertext" data-hover={removeTags(desc)}>
                                                                     <div className={`grade-elem${active ? ' active' : ''}`}></div>
                                                                 </HoverText>
                                                             ))
                                                         }
                                                     </Grid> :
                                                     ''
                                             }
                                             {
                                                 this.state.daysLeft ?
                                                     <div className="grade-reset md-font-size">{t('main-grade-reset')} {this.state.daysLeft}</div>
                                                     :
                                                     <React.Fragment>
                                                         {
                                                             !isEmpty(this.state.grade.current) ?
                                                                 <div className="grade-reset md-font-size">{t('main-grade-reset-time')}</div>
                                                                 : ''
                                                         }
                                                     </React.Fragment>
                                                    
                                             }
                                             <StyledNavLink onClick={() => this.props.history.push('/study-history/1')}>{t('main-grade-more', { _: 'More' })}</StyledNavLink>
                                         </div>
                                         :
                                         <div className="grade">
                                             <Skeleton className="text sm-font-size" height={50} />
                                         </div>
                                 }
                             </div>
                         </CardBody>
                     </Card>
                }
                {
                    this.props.widgetType === 'category' &&
                    <Card className="main-profile d-flex flex-column">
                        <CardHeader className="header">
                            <div className="content">
                                <CardTitle className="title xl-font-size">{t('main-profile')}</CardTitle>
                            </div>
                            <img className="profile-card-bg" src={profileCardBg} alt="" width={309} height={157}></img>
                            <div className="profile-img-wrapper d-flex">
                                {
                                    this.props.profileInfo.avatar.medium ?
                                        <img className="profile-card-img" width="128" height="128" src={this.props.profileInfo.avatar.medium} alt=""></img>
                                        :
                                        <Skeleton className="profile-card-img" circle={true} height={128} width={128} />
                                }
                            </div>
                        </CardHeader>
                        <CardBody className="body">
                            <div className="certificate-icons">
                                <div className="float-left">
                                    {
                                        this.props.medal3 ?
                                            <img src={firstCertificate} alt="" width="55" height="55" /> :
                                            <img src={firstCertificateGrey} alt="" width="55" height="55" />
                                    }
                                    {
                                        this.props.medal2 ?
                                            <img src={secondCertificate} alt="" width="55" height="55" /> :
                                            <img src={secondCertificateGrey} alt="" width="55" height="55" />
                                    }
                                </div>
                                <div className="floar-right">
                                    {
                                        this.props.medal1 ?
                                            <img src={thirdCertificate} alt="" width="55" height="55" /> :
                                            <img src={thirdCertificateGrey} alt="" width="55" height="55" />
                                    }
                                    {
                                        this.props.medal4 ?
                                            <img src={forthCertificate} alt="" width="55" height="55" /> :
                                            <img src={forthCertificateGrey} alt="" width="55" height="55" />
                                    }
                                </div>
                            </div>
                            <div className="content">
                                {
                                    this.props.profileStatus !== null ?
                                        <div className="name lg-font-size" dangerouslySetInnerHTML={{ __html: t(`user-status-${this.props.profileStatus}`) }}></div>
                                        :
                                        <React.Fragment>
                                            <Skeleton className="name lg-font-size" width={150} />
                                            <Skeleton className="name lg-font-size" width={75} />
                                        </React.Fragment>
                                }
                                {
                                    this.props.membershipStatus !== null ?
                                        this.props.membershipStatus ?
                                            <div className="vip">
                                                <Star size={20} weight="fill" className="icon" />
                                                <div className="text sm-font-size">{t('main-vip-member')} ({this.props.membershipEnd})</div>
                                            </div> :
                                            <div className="vip">
                                                <Star size={20} weight="bold" color="#AFAFAF" />
                                                <div className="text sm-font-size">{t('main-vip-notmember')}</div>
                                            </div>
                                        :
                                        <div className="vip">
                                            <Skeleton className="text sm-font-size" width={200} />
                                        </div>
                                }
                            </div>
                        </CardBody>
                    </Card>
                }
                {
                    this.props.widgetType === 'user_status' &&
                    <Card className="main-profile d-flex flex-column">
                        <CardHeader className="header mb-0">
                            <div className="content">
                                <CardTitle className="title text-uppercase xl-font-size">{t('main-current-status')}</CardTitle>
                            </div>
                        </CardHeader>
                        <CardBody className={`d-flex flex-column body pt-20px${!this.props.userStatus.certificate ? ' no-img' : ''}`}>
                            {
                                this.props.userStatusLoaded ?
                                    !isEmpty(this.props.userStatus.certificate) ?
                                        <React.Fragment>
                                            {!this.state.imageLoaded && <div className="main-cert-img user_status m-0"><Skeleton height={200} image={true} /></div>}
                                            {<img onClick={() => window.open(`${this.props.imageUrl}/${this.props.userStatus.certificateFile}`, "_blank")} onLoad={() => this.setState({ imageLoaded: true })} src={`${this.props.imageUrl}/${this.props.userStatus.certificate}`} alt="" className={`main-cert-img user_status${this.state.imageLoaded ? '' : ' d-none'}`} />}
                                        </React.Fragment>
                                        :
                                        <div className="xl-font-size">{t('main-no-certificate')}</div>
                                    :
                                    <div className="main-cert-img user_status m-0"><Skeleton height={200} image={true} /></div>
                            }
                            {
                                this.props.userStatusLoaded ?
                                    <UserStatus>
                                        <div className="status-wrapper">
                                            <div className="title lg-font-size">{t('main-current-status')}</div>
                                            <div className='status md-font-size' style={{
                                                backgroundColor: this.props.userStatus.status.color,
                                                color: this.props.userStatus.status.fontColor,
                                            }}>{this.props.userStatus.status.title}</div>
                                        </div>
                                    </UserStatus>
                                    :
                                    <UserStatus>
                                        <div className="status-wrapper">
                                            <Skeleton className="title lg-font-size" width={150}></Skeleton>
                                            <Skeleton className='status md-font-size' width={100}></Skeleton>
                                        </div>
                                    </UserStatus>
                            }
                        </CardBody>
                    </Card>
                }
            </React.Fragment>
        )
    }
}

AchieveCard.propTypes = {
    history: PropTypes.object,
    i18n: PropTypes.object,
    t: PropTypes.func,
    widgetType: PropTypes.string,
    profileInfo: PropTypes.object,
    membershipStatus: PropTypes.any,
    profileStatus: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    medal3: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
    ]),
    medal2: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
    ]),
    medal1: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
    ]),
    medal4: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
    ]),
    membership: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
    ]),
    membershipEnd: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
    ]),
    lastCertificate: PropTypes.object,
    imageUrl: PropTypes.string,
    lastCertificateLoaded: PropTypes.bool,
    userStatusLoaded: PropTypes.bool,
    userStatus: PropTypes.object,
}

export default withTranslation()(AchieveCard)


// WEBPACK FOOTER //
// ./src/components/Main/AchieveCard.jsx